import React from 'react';
import NoData from '../../components/fragments/IllustrationState/NoData';
import { ERROR_STATE } from '../../constants/defaultValues/errorState';
import { Grid } from '@mantine/core';
import CardMission from '../../components/card_mission';

const MissionActive = ({ data, activeTab }) => {
  if (activeTab !== 'active') return null;

  if (data.length === 0) {
    return <NoData title={ERROR_STATE.empty[0]} w={200} />;
  }
  return (
    <Grid>
      {data.map((mission, index) => (
        <CardMission key={index} item={mission} />
      ))}
    </Grid>
  );
};

export default MissionActive;
